<script>
  import {createEventDispatcher} from 'svelte';
  import {timeUtil} from '@/helper/time';
  import {csRobotUtil} from '@/da/cs-robot';
  import {Button} from '@px/button';
  import {ipRestrictedConfig$, isIpPreRestricted$, isIpRestricted$, isIpRestrictedRegister$} from '@/modules/components/ip-restricted/streams';
  import Modal from '@/widgets/Modal.svelte';
  import lang from '../RegisterPage.lang';
  import restrictedLang from '@/modules/components/ip-restricted/IpRestricted.lang';

  export let LG = null;
  export let entrance = '';

  const dispatch = createEventDispatcher();
  const Email = '<a class="noa" href="mailto:support@phemex.zendesk.com">support@phemex.zendesk.com</a>';

  function handleCloseClick() {
    dispatch('close');
  }

  function handleSupportClick() {
    csRobotUtil.openChat();
    dispatch('close');
  }
</script>

<style>
  .footer {
    margin: 40px auto 0;
  }
  .mt42 {
    margin-top: 42px;
  }
  .button {
    justify-content: flex-end;
  }
  .button :global(button.primary) {
    border-radius: 32px;
    border-color: var(--BTN-BG);
    background: var(--BTN-BG);
    color: var(--BTN-COLOR);
  }
  .button :global(button.default) {
    border-radius: 32px;
    border-color: var(--BTN-BG);
    color: var(--BTN-BG);
  }
  @media screen and (max-width: 640px) {
    .button {
      justify-content: space-between;
    }
  }
</style>

<Modal visible>
  <div class="lh24 b f16 T2 df jcsb" slot="header">
    <div class="lh24 fw2 f18 T1">{LG(lang.RestrictedIP)}</div>
  </div>
  <div class="footer df fdc" slot="footer">
    <div>
      <div class="f14 t2 fw2 lh22">
        {#if $isIpRestricted$ || entrance === 'Register'}
          {@html LG(restrictedLang.restrictedMsg, {Email})}
        {:else if $isIpPreRestricted$}
          {@html LG(restrictedLang.preRestrictedMsg, {Email, Date: timeUtil.formatUTCDate($ipRestrictedConfig$ && $ipRestrictedConfig$.startTime)})}
        {:else if $isIpRestrictedRegister$}
          {LG(lang.Note)}
        {/if}
      </div>
      <div class="df button mt42">
        <Button type="primary" on:click={handleSupportClick}>{LG(lang.ContactSupport)}</Button>
        <Button class="ml24" type="default" on:click={handleCloseClick}>Ok</Button>
      </div>
    </div>
  </div>
</Modal>
